import type { FinancialSnapshotTemplate } from '../financial-snapshot.model';
import { MacroCategory } from '../financial-snapshot.model';

/** Seeded from backend assessment GET /financialsnapshot/template. */
export const FINANCIAL_SNAPSHOT_TEMPLATE_FIXTURE: FinancialSnapshotTemplate = {
  monthlyhouseholdincome: {
    order: 0,
    name: 'Monthly household income',
    macroCategory: MacroCategory.income,
    instructions:
      'What is the total monthly take-home pay for all members of your household (not just you)? You can enter a total amount or expand the screen to break down your income types below',
    locked: true,
    totalLabel: 'Total monthly household income',
    subCategories: {
      takehomepay: { order: 1, label: 'Your monthly take-home pay' },
      otherhouseholdtakehomepay: { order: 2, label: 'Other household take-home pay' },
      otherincome: { order: 3, label: 'Other income (side gig, rental income, etc.)' },
    },
  },
  housing: {
    order: 1,
    displayOrder: 1,
    name: 'Housing',
    macroCategory: MacroCategory.spending,
    instructions: 'Enter your monthly spending on housing. This does not include utilities.',
    locked: true,
    totalLabel: 'Total housing cost',
    subCategories: {
      rentmortgage: { order: 1, label: 'Rent/Mortgage' },
      homerenterinsurance: { order: 2, label: "Home/Renter's insurance" },
      hoafees: { order: 3, label: 'HOA fees' },
    },
  },
  utilities: {
    order: 2,
    displayOrder: 2,
    name: 'Utilities',
    macroCategory: MacroCategory.spending,
    instructions: 'Enter your monthly spending on utilities.',
    locked: true,
    totalLabel: 'Total utilities cost',
    subCategories: {
      electricgas: { order: 1, label: 'Electric/gas' },
      watersewer: { order: 2, label: 'Water/sewer' },
      cableinternet: { order: 3, label: 'Cable internet' },
      cellphone: { order: 4, label: 'Cell phone' },
    },
  },
  transportation: {
    order: 3,
    displayOrder: 3,
    name: 'Transportation',
    macroCategory: MacroCategory.spending,
    instructions: 'Enter your monthly spend on transportation.',
    locked: true,
    totalLabel: 'Total transportation cost',
    subCategories: {
      carpayments: { order: 1, label: 'Car payments' },
      fuel: { order: 2, label: 'Fuel' },
      carinsurance: { order: 3, label: 'Car insurance' },
      publictransportation: { order: 4, label: 'Public transportation (bus, subway, etc.)' },
    },
  },
  food: {
    order: 4,
    displayOrder: 4,
    name: 'Food',
    macroCategory: MacroCategory.spending,
    instructions: 'Enter your monthly spending on food.',
    locked: true,
    totalLabel: 'Total food cost',
    subCategories: {
      groceries: { order: 1, label: 'Groceries' },
      restaurantscoffee: { order: 2, label: 'Restaurants/coffee' },
      takeout: { order: 3, label: 'Take out (including Grubhub, Doordash, Uber eats, etc.)' },
    },
  },
  dependentcare: {
    order: 5,
    displayOrder: 5,
    name: 'Dependent care',
    macroCategory: MacroCategory.spending,
    instructions: 'Enter your monthly spending on dependents.',
    locked: true,
    totalLabel: 'Total dependent care cost',
    subCategories: {
      childsupport: { order: 1, label: 'Child support' },
      daycare: { order: 2, label: 'Day care' },
      petexpenses: { order: 3, label: 'Pet expenses' },
    },
  },
  subscriptions: {
    order: 6,
    displayOrder: 6,
    name: 'Subscriptions',
    macroCategory: MacroCategory.spending,
    instructions: 'Enter your monthly spending on subscriptions and other recurring expenses.',
    locked: true,
    totalLabel: 'Total subscriptions cost',
    subCategories: {
      gamingaudiobooks: { order: 1, label: 'Gaming/audiobooks' },
      videostreamingservices: { order: 2, label: 'Amazon/Netflix, etc.' },
      gymmembership: { order: 3, label: 'Gym membership' },
    },
  },
  debtrepayment: {
    order: 7,
    displayOrder: 7,
    name: 'Debt Repayment',
    macroCategory: MacroCategory.spending,
    instructions:
      'Enter your monthly PAYMENTS (not your current balance) for credit cards, loans, or other debt.',
    locked: true,
    totalLabel: 'Total monthly debt payments',
    subCategories: {
      personalloans: { order: 1, label: 'Other loan payments' },
      studentloans: { order: 2, label: 'Student loan payments' },
      creditcards: { order: 3, label: 'Credit card payments' },
    },
  },
  other: {
    order: 8,
    displayOrder: 8,
    name: 'Other',
    macroCategory: MacroCategory.spending,
    instructions:
      'Enter other types of spending you have each month. You can add as many additional custom categories as you need.',
    locked: false,
    subCategories: {
      activities: { order: 1, label: 'Activities (entertainment, sports, travel, etc.)' },
      medical: { order: 2, label: 'Medical (prescriptions, co-pays, etc.)' },
      personal: { order: 3, label: 'Personal (shopping, beauty, cigarettes, etc.)' },
    },
  },
  savings: {
    order: 9,
    displayOrder: 9,
    name: 'Savings',
    macroCategory: MacroCategory.savings,
    instructions:
      'How much do you typically save each month? Do not include contributions to 401k, 529 plans, Roth IRAs, etc.',
    locked: true,
  },
};
